import React from "react";
import {Box, IconButton} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import Tooltip from "@material-ui/core/Tooltip";
import {useCurrentPublicShow, useCurrentShow} from "hooks";
import {apiV2} from "api/firebase";
import {IGlossary} from "@evennt-tech/api-v2-core";

type HideAllButtonProps = {
  glossary: IGlossary;
};

const HideAllButton = ({glossary}: HideAllButtonProps) => {
  const [show] = useCurrentPublicShow();

  const handleIconClick = async () => {
    if (!glossary) {
      return null;
    }
    if (!show) {
      return null;
    }

    await apiV2.glossary.update({
      glossaryId: glossary.id,
      includeAllCategory: !glossary.includeAllCategory,
      showId: show.id,
    });
  };

  if (!show) {
    return null;
  }

  const icon = glossary.includeAllCategory ? (
    <VisibilityIcon />
  ) : (
    <VisibilityOffIcon />
  );
  const title = glossary.includeAllCategory
    ? "Hide category"
    : "Display category";

  return (
    <Box>
      <Tooltip title={title}>
        <IconButton onClick={handleIconClick}>{icon}</IconButton>
      </Tooltip>
    </Box>
  );
};

export default HideAllButton;
